import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isLogin) {
        await login(formData.email, formData.password);
        toast.success('Login realizado com sucesso!');
      } else {
        await register(formData.name, formData.email, formData.password);
        toast.success('Cadastro realizado com sucesso!');
      }
      navigate('/catalogo');
    } catch (error) {
      const message = error.response?.data?.detail || (isLogin ? 'Erro ao fazer login' : 'Erro ao cadastrar');
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center justify-center py-20">
      <div className="px-6 md:px-12 w-full max-w-md">
        <div className="text-center mb-12">
          <h1 data-testid="auth-title" className="font-heading text-4xl md:text-5xl font-light tracking-tight mb-4">
            {isLogin ? 'Entrar' : 'Cadastrar'}
          </h1>
          <p className="text-base font-light text-muted-foreground">
            {isLogin ? 'Acesse sua conta' : 'Crie sua conta'}
          </p>
        </div>

        <form onSubmit={handleSubmit} data-testid="auth-form" className="space-y-8">
          {!isLogin && (
            <div>
              <label className="font-accent text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
                Nome
              </label>
              <input
                type="text"
                data-testid="name-input"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required={!isLogin}
                className="w-full bg-transparent border-b border-border focus:border-primary px-0 py-4 focus:ring-0 outline-none transition-colors duration-300 placeholder:text-muted-foreground/50"
                placeholder="Seu nome completo"
              />
            </div>
          )}

          <div>
            <label className="font-accent text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
              E-mail
            </label>
            <input
              type="email"
              data-testid="email-input"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="w-full bg-transparent border-b border-border focus:border-primary px-0 py-4 focus:ring-0 outline-none transition-colors duration-300 placeholder:text-muted-foreground/50"
              placeholder="seu@email.com"
            />
          </div>

          <div>
            <label className="font-accent text-xs uppercase tracking-widest text-muted-foreground mb-2 block">
              Senha
            </label>
            <input
              type="password"
              data-testid="password-input"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="w-full bg-transparent border-b border-border focus:border-primary px-0 py-4 focus:ring-0 outline-none transition-colors duration-300 placeholder:text-muted-foreground/50"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            data-testid="submit-button"
            disabled={loading}
            className="w-full bg-primary text-white px-8 py-4 uppercase tracking-widest text-xs hover:bg-black transition-all duration-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Processando...' : isLogin ? 'Entrar' : 'Cadastrar'}
          </button>
        </form>

        <div className="mt-8 text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            data-testid="toggle-auth-mode"
            className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
          >
            {isLogin ? 'Não tem uma conta? Cadastre-se' : 'Já tem uma conta? Entrar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;